import { render, staticRenderFns } from "./TextAreaModal.vue?vue&type=template&id=70a26917"
import script from "./TextAreaModal.vue?vue&type=script&lang=js"
export * from "./TextAreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports